import { useSelector } from 'react-redux';
import {
  selectFilterData,
  selectCreationFormData
} from 'pages/PicklistAndLeavelist/PicklistSummary/selectors';

export function usePicklistSelector() {
  const filter = useSelector(selectFilterData());
  const creationForm = useSelector(selectCreationFormData());

  return {
    filter,
    creationForm
  };
}
